export default __webpack_public_path__ + "static/media/logo.6de3de26.png";